import { createSlice } from '@reduxjs/toolkit'
import { studio } from 'redux/persist'

export interface IPlan {
  id: string
  name: string
  description: string
  campaignName: string
  type: string
  isDefault: boolean
  membershipPrice: number | null
  applicableToAllCycle: boolean | null
  stripeProductId: string
  count: number
  amount: number
  frequency: string | null
  maxCount: number
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface ITime {
  index: number
  value: string
}

interface IScheduleInitialValues {
  scheduleObject: {
    appointmentTime: string
    timezone: string
    clinicId: string | undefined | null
  }
  index?: number | null
  value?: ITime | null
  date?: any
}

interface VisitCount {
  onDemandCount: number | null
  subscriptionCount: number | null
  previousVisits: boolean
}

interface PurchasedPlan {
  clientSecret: string
  paymentId: string
  paymentIntentId: string
}

export interface SignUpState {
  availablePlansSignUp: Array<IPlan>
  selectedPlanSignUp: IPlan | null
  selectedSlotSignUp: IScheduleInitialValues | null
  slotBookedAlreadySignUp: boolean
  slotNotFoundSignUp: boolean
  paymentDoneSignUp: any | null
  purchasedPlanSignUp: PurchasedPlan | null
  visitCountSignUp: VisitCount | null
  referralCodeSignUp: string | null
  timeLeftToExpireSignUp: number | null
  timeLeftSignUp: number | null
  studiosSignUp: Array<studio>
  selectedStudioSignUp: studio | null
  isMoreThanOneStudioSignUp: boolean
  leadType: string | null
  firstname: string
  phoneNumber: string
  formattedPhoneNumber: string
  channel: string
  trackerCountSignUp: number
  userId: string | null
}

const initialState: SignUpState = {
  availablePlansSignUp: [],
  selectedPlanSignUp: null,
  selectedSlotSignUp: null,
  slotBookedAlreadySignUp: false,
  slotNotFoundSignUp: false,
  paymentDoneSignUp: null,
  purchasedPlanSignUp: null,
  visitCountSignUp: null,
  referralCodeSignUp: null,
  timeLeftToExpireSignUp: null,
  timeLeftSignUp: null,
  studiosSignUp: [],
  selectedStudioSignUp: null,
  isMoreThanOneStudioSignUp: false,
  leadType: null,
  firstname: '',
  phoneNumber: '',
  formattedPhoneNumber: '',
  channel: '',
  trackerCountSignUp: 0,
  userId: null,
}

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    SetAvailablePlansSignUp: (state, action) => {
      state.availablePlansSignUp = action.payload
    },
    SetSelectedPlanSignUp: (state, action) => {
      state.selectedPlanSignUp = action.payload
    },
    SetSelectedSlotSignUp: (state, action) => {
      state.selectedSlotSignUp = action.payload
    },
    SetSlotBookedAlreadySignUp: (state, action) => {
      state.slotBookedAlreadySignUp = action.payload
    },
    SetSlotNotFoundSignUp: (state, action) => {
      state.slotNotFoundSignUp = action.payload
    },
    SetPurchasedPlanSignUp: (state, action) => {
      state.purchasedPlanSignUp = action.payload
    },
    SetVisitCountSignUp: (state, action) => {
      state.visitCountSignUp = action.payload
    },
    SetPaymentDoneSignUp: (state, action) => {
      state.paymentDoneSignUp = action.payload
    },
    SetReferralCodeSignUp: (state, action) => {
      state.referralCodeSignUp = action.payload
    },
    SetTimeLeftToExpireSignUp: (state, action) => {
      state.timeLeftToExpireSignUp = action.payload
    },
    SetTimeLeftSignUp: (state, action) => {
      state.timeLeftSignUp = action.payload
    },
    SetStudiosSignUp: (state, action) => {
      state.studiosSignUp = action.payload
    },
    SetSelectedStudioSignUp: (state, action) => {
      state.selectedStudioSignUp = action.payload
    },
    SetIsMoreThanOneStudioSignUp: (state, action) => {
      state.isMoreThanOneStudioSignUp = action.payload
    },
    SetLeadTypeSignUp: (state, action) => {
      state.leadType = action.payload
    },
    SetFirstNameSignUp: (state, action) => {
      state.firstname = action.payload
    },
    SetChannelSignUp: (state, action) => {
      state.channel = action.payload
    },
    SetPhoneNumberSignUp: (state, action) => {
      state.phoneNumber = action.payload
    },
    SetFormattedPhoneNumberSignUp: (state, action) => {
      state.formattedPhoneNumber = action.payload
    },
    SetTrackerCountSignUp: (state, action) => {
      state.trackerCountSignUp = action.payload
    },
    SetUserIdSignUp: (state, action) => {
      state.userId = action.payload
    },
  },
})

export default signUpSlice.reducer

export const {
  SetSelectedPlanSignUp,
  SetSelectedSlotSignUp,
  SetAvailablePlansSignUp,
  SetSlotBookedAlreadySignUp,
  SetSlotNotFoundSignUp,
  SetPurchasedPlanSignUp,
  SetVisitCountSignUp,
  SetPaymentDoneSignUp,
  SetReferralCodeSignUp,
  SetTimeLeftToExpireSignUp,
  SetTimeLeftSignUp,
  SetStudiosSignUp,
  SetSelectedStudioSignUp,
  SetIsMoreThanOneStudioSignUp,
  SetLeadTypeSignUp,
  SetFirstNameSignUp,
  SetChannelSignUp,
  SetPhoneNumberSignUp,
  SetFormattedPhoneNumberSignUp,
  SetTrackerCountSignUp,
  SetUserIdSignUp,
} = signUpSlice.actions
